import { useState } from 'react'
import DataTable from '../components/DataTable'
import { KTSVG } from '../../_metronic/helpers'
import { Link } from "react-router-dom";
import Error from '../components/Error500'
import GetPagePermission from "../components/GetPagePermission";
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import ProjectCreate from '../components/ProjectCreate';

function ProjectsManagement() {

    const hasPermission = GetPagePermission("/setup-company-list");
    const [newData, setNewData] = useState({});
    const [id, setId] = useState(0);

    const [createProjectModalShow, setCreateProjectModalShow] = useState(false);

    const handleCreateProjectModalShow = () => {
        setId(0)
        setCreateProjectModalShow(true);
    }

    const handleCreateProjectModalClose = (isReload: boolean) => {
        setCreateProjectModalShow(false);
        if (isReload) {
            setNewData({ id: Date.now() });
        }
    }

    const editItem = (id: number): void => {
        setId(id);
        setCreateProjectModalShow(true);
    };

    const deleteItem = (id: number): void => {
        if (window.confirm("Are you sure you want to delete this item?")) {
            const myToken: string | null = localStorage.getItem('MyToken');
            let jwt: string | null = (myToken != null) ? JSON.parse(myToken) : null;
            fetch(`${process.env.REACT_APP_API_URL}items/${id}`, {
                method: 'DELETE',
                headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${jwt}` }
            })
                .then((resp: Response) => {
                    return resp.json();
                })
                .then((resp: any) => {
                    if (resp.success) {
                        const successMsg: string = resp.successMessage;
                        Swal.fire({
                            icon: 'success',
                            title: 'Deleted!',
                            text: successMsg,
                        });
                        setNewData({ id: Date.now() });
                    }
                })
                .catch((error: any) => {
                    console.log(error, 'catch the hoop');
                });
        }
    };

    const columns = [
        { value: 'id', title: 'Id', style: { textAlign: 'center' } },
        { value: 'projectName', title: 'Name', style: { textAlign: 'left' } },
        { value: 'projectShortName', title: 'Short Name', style: { textAlign: 'left' } },
        { value: 'projectAddress', title: 'Address', style: { textAlign: 'left' } },
        { value: 'accountantApproval', title: 'Accountant Approval', style: { textAlign: 'left' }},
        { value: 'projectStatus', title: 'Status', style: { textAlign: 'left' } },
        { value: 'createdBy', title: 'Created By', style: { textAlign: 'left' } },
        {
            value: 'action', title: 'Action', style: { textAlign: 'left', whiteSpace: 'nowrap' }, hasActionsComponent: true, actionsComponent: ((row: any) => {
                return (
                    <>
                        <button className="btn btn-light-primary btn-sm px-2 py-1" onClick={() => editItem(row.idProjects)}>
                            <KTSVG
                                path='/media/svg/icons/Communication/Write.svg'
                                className='svg-icon-5 svg-icon'
                            />		Edit
                        </button>
                        <button className="btn btn-light-danger btn-sm px-2 py-1">
                            <KTSVG
                                path='/media/svg/icons/General/Trash.svg'
                                className='svg-icon-5 svg-icon'
                            />		Delete
                        </button>
                        <Link to={`/project-stage/${row.idProjects}`}>
                            <button className="btn btn-light-info btn-sm px-2 py-1" onClick={() => deleteItem(row.idProjects)}>
                                <KTSVG
                                    path='/media/svg/icons/General/User.svg'
                                    className='svg-icon-5 svg-icon'
                                />		Manage Stage
                            </button>
                        </Link>
                    </>
                )
            })
        }
    ]

    const filters = {
        id: {
            filterType: 'like',
            filterValue: '',
        },
        projectName: {
            filterType: 'like',
            filterValue: '',
        },
        projectShortName: {
            filterType: 'like',
            filterValue: '',
        },
        projectAddress: {
            filterType: 'like',
            filterValue: '',
        },
        accountantApproval: {
            filterType: 'like',
            filterValue: '',
        },
        projectStatus: {
            filterType: 'like',
            filterValue: '',
        },
        createdBy: {
            filterType: 'like',
            filterValue: '',
        }
    }

    const url = process.env.REACT_APP_API_URL + 'projects/dt'


    return (
        <>
            {hasPermission === 1 &&
                <div className='card card-custom'>
                    <div className='card-header'>
                        <div className="card-title">
                            <KTSVG path='/media/svg/icons/Text/Bullet-list.svg' className='svg-icon-1 svg-icon-primary' />
                            <span className='text fw-bolder' style={{ marginLeft: '10px' }}>
                                Projects
                            </span>
                        </div>
                        <div className="card-toolbar">
                            <div className='d-flex justify-content-end'>
                                <button type="button" className="btn btn-sm btn-primary" onClick={() => handleCreateProjectModalShow()}><i className="fa fa-plus"></i>Add Project</button>
                            </div>
                        </div>
                    </div>

                    <div className='card-body'>
                        <DataTable url={url} columns={columns} filters={filters} newData={newData} />
                    </div>
                </div>
            }


            <ProjectCreate show={createProjectModalShow} handleClose={handleCreateProjectModalClose} id={id} />
            {hasPermission === 0 &&
                <Error />
            }
            {hasPermission === 0 &&
                <div className='card card-custom' style={{ padding: "15px" }} >
                    <SkeletonTheme>
                        <p>
                            <Skeleton
                                containerClassName="avatar-skeleton"
                                count={40} ></Skeleton>
                        </p>
                    </SkeletonTheme>
                </div>
            }
        </>
    )
}

export default ProjectsManagement
